import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function CtaSection() {
  return <section className="py-20 bg-cream text-center px-4" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-13">
          <h2 className="font-handwritten text-5xl md:text-6xl text-forestGreen mb-4" data-id="element-14">
            Ruhige Morgen für dich und deinen Hund
          </h2>
          <p className="font-serif text-xl text-warmBrown mb-10" data-id="element-15">
            Teste das Magen-Darm-Topping jetzt risikofrei – mit
            Geld-zurück-Garantie.
          </p>

          <motion.a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-forestGreen text-white font-serif font-bold text-xl py-4 px-8 rounded-full shadow-lg hover:bg-forestGreen/90 transition-colors mb-8" data-id="element-16">
            Jetzt für meinen Hund entdecken →
          </motion.a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-serif text-gray-600" data-id="element-17">
            <div className="flex items-center gap-1" data-id="element-18">
              <Check className="w-4 h-4 text-forestGreen" data-id="element-19" />
              <span data-id="element-20">Schneller Versand</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-21">
              <Check className="w-4 h-4 text-forestGreen" data-id="element-22" />
              <span data-id="element-23">Zufriedenheitsgarantie</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-24">
              <Check className="w-4 h-4 text-forestGreen" data-id="element-25" />
              <span data-id="element-26">100% Natürliche Inhaltsstoffe</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}